import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import Application from './Reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/*
uncomment for debugging purpose only, don't leave it for production
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        trace: true,
        traceLimit: 20,
      })
    : compose;*/

let store = createStore(Application, composeEnhancers(applyMiddleware(thunk)));

export default store;
